export default "assets/images/icons/deco-79a72162.svg";